import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { KycGlobalPage } from "./legal.kyc-global";

export const Route = createFileRoute("/vi/legal/kyc-global")({
  head: () => ({
    meta: [{ title: "KYC & Xác minh (Toàn cầu) — Banana Cards" }],
    links: alternateLinkList("/legal/kyc-global", "vi"),
  }),
  component: KycGlobalPage,
});